import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { SiteSearch } from "@/components/site/SiteSearch";

const LINKS = [
  { to: "/about", id: "about", label: "About" },
  { to: "/articles", id: "articles", label: "Articles" },
  { to: "/projects", id: "projects", label: "Projects" },
  { to: "/community", id: "community", label: "Community" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const isHome = useRef(window.location.pathname === "/");
  const { content } = useContent();
  const brand = content.brand;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled || !isHome.current
          ? "bg-[#050a14]/95 border-slate-800 backdrop-blur"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-display font-black text-xl tracking-tight text-slate-100"
        >
          {brand.name_pre}<span className="text-sky-400"> {brand.name_accent}</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.id}
              to={l.to}
              data-testid={`nav-${l.id}`}
              className="font-mono-tech text-xs uppercase tracking-[0.18em] text-slate-400 hover:text-sky-400 transition-colors"
            >
              {l.label}
            </Link>
          ))}
          <SiteSearch />
        </nav>

        <div className="md:hidden flex items-center gap-5">
          <SiteSearch testid="nav-mobile-search" />
        <button
            className="md:hidden text-slate-200"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#050a14] border-t border-slate-800 px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <Link
              key={l.id}
              to={l.to}
              data-testid={`nav-mobile-${l.id}`}
              onClick={() => setOpen(false)}
              className="font-mono-tech text-left text-xs uppercase tracking-[0.18em] text-slate-300"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
